// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"b6a960c9","667":"28851b52","977":"63e529bb"}[chunkId] + ".chunk.js";
};